'use strict';



const $ = require('jquery');
const keycode = require('keycode');
const api = 'https://pcls1.craftyclicks.co.uk/json/rapidaddress';



module.exports = class SuggestAddress {



	constructor(options) {

		this.options = options;
		const $container = $(`.${options.className}`);

		if($container.length < 1) {
			return;
		}

		const $input = $container.find('input');
		const $trigger = $container.find(`.${options.className}-trigger`);
		const $results = $container.find(`.${options.className}-results`);
		const $line1 = $(`.${options.className}-line1`);
		const $line2 = $(`.${options.className}-line2`);
		const $town = $(`.${options.className}-town`);
		const $country = $(`.${options.className}-country`);

		this.state = this.getInitialState();

		this.elements = {
			$container,
			$input,
			$trigger,
			$results,
			$line1,
			$line2,
			$town,
			$country
		};

		this.init();

	}



	getInitialState() {
		return {
			postcode: null,
			country: 'GBR',
			town: null,
			selected: null,
			loading: false,
			results: []
		};
	}



	init() {

		this.elements.$input.on('keydown', e => {
			if(keycode(e) === 'enter') {
				e.preventDefault();
				this.lookup(this.getInputPostcode());
			}
		});

		this.elements.$results.on('change', e => {
			this.state.selected = this.getInputUdprn();
			this.render();
		});

		this.elements.$trigger.on('click', e => {
			e.preventDefault();
			this.lookup(this.getInputPostcode());
		});

	}



	getInputPostcode() {
		return this.elements.$input.val();
	}



	getInputAddress() {
		return this.state.results.find(result => result.udprn === this.state.selected) || {};
	}



	getInputUdprn() {
		return this.elements.$results.val();
	}



	lookup(postcode) {

		if(!postcode) {
			return;
		}

		this.state.loading = true;
		const key = this.options.apiToken;

		const success = res => {
			if(res.error_code) {
				return this.onError(res);
			}
			return this.onSuccess(res);
		};

		const error = this.onError.bind(this);

		$.ajax({
			url: api,
			data: {
				response: 'data_formatted',
				include_geocode: true,
				key,
				postcode
			},
			dataType: 'json',
			error,
			success
		});

	}



	onSuccess(res) {
		this.state.results = res.delivery_points;
		this.state.town = res.town;
		this.render();
	}



	onError(res) {
		console.log('ERROR', res);
		this.state = this.getInitialState();
		this.render();
	}



	formatResult(result = {}, properties = []) {
		return properties
			.map(property => result[property])
			.filter(property => property)
			.join(', ');
	}



	formatLine1(result) {
		return this.formatResult(result, [
			'organisation_name',
			'department_name',
			'line_1'
		]);
	}



	renderResults() {

		const resultIdentifier = result => {

			const name = this.formatResult(result, [
				'organisation_name',
				'department_name',
				'line_1',
				'line_2'
			]);

			const selected = this.state.selected && result.udprn === this.state.selected ?
				'selected' :
				'';

			return {
				udprn: result.udprn,
				name,
				selected
			};

		};

		if(this.state.results.length < 1) {
			this.elements.$results.empty();
			this.elements.$results.hide();
			return;
		}

		this.elements.$results.show();

		const results = this.state.results
			.map(resultIdentifier)
			.map(result => `<option value=${result.udprn} ${result.selected}>${result.name}</option>`);

		results.unshift('<option>Choose address</option>');

		this.elements.$results.html(results.join(''));

	}



	renderFormValues() {

		if(!this.state.selected) {
			return;
		}

		const address = this.getInputAddress();

		this.elements.$line1.val(this.formatLine1(address));
		this.elements.$line2.val(address.line_2);
		this.elements.$town.val(this.state.town);

		this.elements.$country
			.val(this.state.country)
			.change();

	}



	render() {
		this.renderResults();
		this.renderFormValues();
	}



};